import { makeStyles } from '@material-ui/core/styles';

import COLORS from '../../../constants/colors';

const useStyles = makeStyles(theme => ({
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  card: {
    maxWidth: '1000px',
    margin: '0 auto',
    padding: '12px 16px',
    marginBottom: '24px',
  },
  submit: {
  },
  deleteButton: {
    marginTop: 20,
  },
  deleteText: {
    fontSize: 14,
  },
  confirmDeleteText: {
    fontSize: 14,
    fontWeight: 'bolder',
  },
  feedbackContainer: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    height: 160,
  },
  failedAIText: {
    //color: COLORS.mainRed,
    fontSize: 14,
    fontWeight: 'bold',
    marginBottom: 1,
  },
  failedAIMessagesText: {
    color: COLORS.mainRed,
    fontSize: 16,
    marginTop: 1,
  },
  imageGuideText: {
    color: COLORS.mainGreen,
    fontSize: 12,
    fontWeight: 'bold',
    marginTop: 1,
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: '33.33%',
    flexShrink: 0,
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary,
  },
  note: {
    display: 'block',
    paddingBottom: '10px',
    fontWeight: 700,
    color: theme.palette.primary.dark,
  },
  noteLink: {
    color: "inherit"
  },
  radioLabel: {
    color: "#000",
    lineHeight: '24px',

    '&.Mui-focused': {
      color: "#000",
    },
  },
  // Read-only admin review locks every field via `disabled`. Restyle the disabled
  // fields to read as display values (subtle fill, no border) and — crucially —
  // restore legible text contrast: MUI's disabled grey (rgba(0,0,0,.38) ≈ 2.67:1)
  // fails WCAG AA. Scoped to this class so genuinely-disabled fields in *edit*
  // mode keep their normal greyed-out affordance.
  readOnlyForm: {
    '& .MuiOutlinedInput-root.Mui-disabled': {
      backgroundColor: theme.palette.grey[100],
    },
    '& .MuiOutlinedInput-root.Mui-disabled .MuiOutlinedInput-notchedOutline': {
      borderColor: 'transparent',
    },
    // Dark, high-contrast value text (WebkitTextFillColor defeats WebKit's UA
    // fill on disabled <input>/<select>; opacity:1 resets any stacked fade).
    '& .MuiInputBase-input.Mui-disabled': {
      color: theme.palette.text.primary,
      WebkitTextFillColor: theme.palette.text.primary,
      opacity: 1,
    },
    // Floating labels, radio/checkbox labels and helper text: readable and not greyed out.
    '& .MuiFormLabel-root.Mui-disabled, & .MuiFormControlLabel-label.Mui-disabled, & .MuiFormHelperText-root.Mui-disabled': {
      color: theme.palette.text.primary,
    },
    // Hide write-prompt placeholders and the select arrow so disabled fields read as static values.
    '& .MuiInputBase-input.Mui-disabled::placeholder, & .MuiInputBase-input.Mui-disabled::-webkit-input-placeholder': {
      opacity: 0,
    },
    '& .MuiInputBase-root.Mui-disabled .MuiSelect-icon': {
      display: 'none',
    },
  },
}));

export default useStyles;
